import { isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => {
    if (isDevMode()) {
      /**
       * Exposes a `window.__getState()` helper in development builds so that
       * Playwright (and other e2e tools) can read the current NgRx store state
       * without needing the Redux DevTools browser extension.
       *
       * Usage in a Playwright test:
       *   const state = await page.evaluate(() => window.__getState());
       */
      const store = appRef.injector.get(Store);
      (window as Window & { __getState?: () => Promise<unknown> })[
        '__getState'
      ] = () =>
        new Promise((resolve) =>
          store.pipe(take(1)).subscribe((state) => resolve(state)),
        );
    }
  })
  .catch((err) => console.error(err));
